var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefractotype2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .red-stroke {\n        fill: red;\n      }\n\n      .green-stroke {\n        fill: green;\n      }\n\n      .blue-stroke {\n        fill: blue;\n      }\n\n      .yellow-stroke {\n        fill: yellow;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "red-stroke",
    y: 25,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "green-stroke",
    y: 75,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow-stroke",
    y: 125,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "blue-stroke",
    y: 175,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "red-stroke",
    y: 225,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "green-stroke",
    y: 275,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "yellow-stroke",
    y: 325,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "blue-stroke",
    y: 375,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "red-stroke",
    y: 425,
    width: 500,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "green-stroke",
    y: 475,
    width: 500,
    height: 25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefractotype2);
export default __webpack_public_path__ + "static/media/refractotype2.d6e2f3f9ed020e841483a8b968ecf799.svg";
export { ForwardRef as ReactComponent };